<template>
  <div class="wrap">
    <div class="bannerimg">
      <img src="@/assets/other/design.jpg" alt="" style="width: 100%" />
    </div>
    <Nav title="定制合成" />
    <div class="pagew content">
      <div class="dingzhi">
        <div class="left">
          <div class="info">材料定制</div>
          <div class="info1"> 
            根据客户需求合成有机光电中间体及其他有机功能材料（附材料品质证明或客户检验）。</div>
        </div>
        <div class="right">
          <img src="@/assets/other/2.jpg" alt="" />
        </div>
      </div>
      <div class="hecheng">
        <div class="left">
          <img src="@/assets/other/4.jpg" alt="" />
        </div>
        <div class="right">
          <div class="info">放大合成</div>
          <div class="info1">依客户需要放大生产材料。</div>
        </div>
      </div>
      <!-- <div class="flexbox">
        <div class="left">
          <div class="cont">材料定制<br /><br />放大合成</div>
        </div>
        <div class="right">
          <div class="imgbox">
            <div class="each">
              <div class="title">
                <div class="info">（1）材料定制</div>
                <div class="name">
                  根据客户需求合成有机光电中间体及其他有机功能材料（附材料品质证明或客户检验）
                </div>
              </div>
              <div class="title">
                <div class="info">（2）放大合成</div>
                <div class="name">依客户需要放大生产材料</div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <Footer class="workspace-footer" :show="true" />
  </div>
</template>

<script>
// import Footer from "@/components/Footer/index";
// import Header from "@/components/Header/Header";
import Nav from "../../components/Nav/Nav.vue";
export default {
  name: "cooperation",
  // components: { Footer,Header },
  components: { Nav }
};
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;

  .bannerimg {
    margin-top: 82px;
  }

  .content {
    margin-top: 20px;
    .dingzhi {
      display: flex;
      justify-content: space-between;
      height: 300px;
      .left {
        width: 600px;
        padding: 50px 200px;
        background-color: #f4f9ff;
        text-align: left;
        line-height: 30px;
        .info {
          font-size: 30px;
          font-weight: bold;
        }
        .info1 {
          line-height: 30px;
          font-size: 16px;
          text-align: left;
          margin-top: 10px;
        }
      }

      .right {
        width: 600px;
        img {
          height: 300px;
        }
      }
    }

    .hecheng {
      display: flex;
      justify-content: space-between;
      height: 300px;
      margin-top: 20px;
      .left {
        width: 600px;
        img {
          width: 600px;
          height: 300px;
        }
      }

      .right {
        width: 600px;
        padding: 50px 200px;
        background-color: #f4f9ff;
        text-align: left;
        line-height: 30px;
        .info {
          font-size: 30px;
          font-weight: bold;
        }
        .info1 {
          line-height: 30px;
          font-size: 16px;
          text-align: left;
          margin-top: 10px;
        }
      }
    }
  }

  // .content {
  //   text-align: center;
  //   .flexbox {
  //     width: 100%;
  //     display: flex;
  //     .left {
  //       width: 20%;
  //       height: 650px;
  //       display: flex;
  //       align-items: center;
  //       background-color: #25877d;
  //       .cont {
  //         text-align: center;
  //         width: 85%;
  //         margin: 0 auto;
  //         color: #ffffff;
  //         line-height: 30px;
  //         font-size: 20px;
  //         font-weight: bold;
  //       }
  //     }
  //     .right {
  //       width: 80%;
  //       // height: 50vh;
  //       display: flex;
  //       margin-left: 80px;
  //       line-height: 50px;
  //       .imgbox {
  //         width: 100%;
  //         // height: 50vh;
  //         display: flex;
  //         flex-wrap: wrap;
  //         align-items: center;
  //         justify-content: center;
  //         .each {
  //           width: 200%;
  //           .title {
  //             width: 80%;
  //             margin: 0 auto;
  //             text-align: left;
  //             font-size: 16px;
  //             color: #25877d;
  //             font-weight: bold;
  //             .info {
  //               font-weight: 700;
  //               padding: 10px 0;
  //             }
  //             .name {
  //               font-size: 15px;
  //               color: #000000;
  //               font-weight: 500;
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
}
</style>
<style lang="scss">
.workspace-footer.footerbox {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Match/cooperation.vue